import Vue from 'vue'
import App from './App.vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import locale from 'element-ui/lib/locale/lang/en';
import axios from 'axios'
import router from './router/index'

Vue.prototype.$axios = axios;
Vue.config.productionTip = false
Vue.use(ElementUI,{ locale });

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
